import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { ActionTypes } from '../action'
import { SmeDashboardTypes } from '../Actions'
import {
  GET_EXAM_CREATE_REQUEST_ACTION,
  GET_SME_EXAM_LIST_ACTION,
  GET_EXAM_CREATE_REQUEST_COUNT_ACTION,
  GET_SME_EXAM_PERFORMANCE_ACTION,
  GET_ALL_EXAM_CREATE_REQUEST_ACTION,
} from '../constants/action-types'

const initialState = {
  errorMessage: '',
  examCreateRequestList: {},
  examCreateRequestList_req: {},
  examAllCreateRequestList: {},
  smeExamList: {},
  smeExamCount: {},
  smeExamPerformance: {},
  examCreateRequestListLoading: false,
  examAllCreateRequestListLoading: false,
  smeExamListLoading: false,
  smeExamCountLoading: false,
  smeExamPerformanceLoading: false,
}

const smeDashboardReducer = persistReducer(
  { storage, key: 'sme-dashboard', whitelist: [] },
  (state: SmeDashboardTypes = initialState, action: ActionTypes) => {
    switch (action.type) {
      //For Exam Creation Request
      case GET_EXAM_CREATE_REQUEST_ACTION.GET_EXAM_CREATE_REQUEST_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          examCreateRequestListLoading: true,
        }

      case GET_EXAM_CREATE_REQUEST_ACTION.GET_EXAM_CREATE_REQUEST_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          examCreateRequestListLoading: false,
          examCreateRequestList: action.payload as any,
        }

      case GET_EXAM_CREATE_REQUEST_ACTION.GET_EXAM_CREATE_REQUEST_SUCCESS_REQ:
        return {
          ...state,
          errorMessage: '',
          examCreateRequestListLoading: false,
          examCreateRequestList_req: action.payload as any,
        }

      case GET_EXAM_CREATE_REQUEST_ACTION.GET_EXAM_CREATE_REQUEST_FAILED:
        return {
          ...state,
          errorMessage: '',
          examCreateRequestListLoading: false,
        }

      // SME exam list
      case GET_SME_EXAM_LIST_ACTION.GET_SME_EXAM_LIST_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          smeExamListLoading: true,
        }

      case GET_SME_EXAM_LIST_ACTION.GET_SME_EXAM_LIST_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          smeExamListLoading: false,
          smeExamList: action.payload as any,
        }

      case GET_SME_EXAM_LIST_ACTION.GET_SME_EXAM_LIST_FAILED:
        return {
          ...state,
          errorMessage: '',
          smeExamListLoading: false,
        }

      // SME exam count
      case GET_EXAM_CREATE_REQUEST_COUNT_ACTION.GET_EXAM_CREATE_REQUEST_COUNT_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          smeExamCountLoading: true,
        }

      case GET_EXAM_CREATE_REQUEST_COUNT_ACTION.GET_EXAM_CREATE_REQUEST_COUNT_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          smeExamCountLoading: false,
          smeExamCount: action.payload as any,
        }

      case GET_EXAM_CREATE_REQUEST_COUNT_ACTION.GET_EXAM_CREATE_REQUEST_COUNT_FAILED:
        return {
          ...state,
          errorMessage: '',
          smeExamCountLoading: false,
        }

      //Sme exam performance
      case GET_SME_EXAM_PERFORMANCE_ACTION.GET_SME_EXAM_PERFORMANCE_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          smeExamPerformanceLoading: true,
        }

      case GET_SME_EXAM_PERFORMANCE_ACTION.GET_SME_EXAM_PERFORMANCE_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          smeExamPerformanceLoading: false,
          smeExamPerformance: action.payload as any,
        }

      case GET_SME_EXAM_PERFORMANCE_ACTION.GET_SME_EXAM_PERFORMANCE_FAILED:
        return {
          ...state,
          errorMessage: '',
          smeExamPerformanceLoading: false,
        }

      //For All Exam Creation Request
      case GET_ALL_EXAM_CREATE_REQUEST_ACTION.GET_ALL_EXAM_CREATE_REQUEST_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          examAllCreateRequestListLoading: true,
        }

      case GET_ALL_EXAM_CREATE_REQUEST_ACTION.GET_ALL_EXAM_CREATE_REQUEST_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          examAllCreateRequestListLoading: false,
          examAllCreateRequestList: action.payload as any,
        }

      case GET_ALL_EXAM_CREATE_REQUEST_ACTION.GET_ALL_EXAM_CREATE_REQUEST_FAILED:
        return {
          ...state,
          errorMessage: '',
          examAllCreateRequestListLoading: false,
        }
      default:
        return state
    }
  }
)

export default smeDashboardReducer
